import { useEffect } from 'react';
import { useLocation } from 'react-router';
import moment from 'moment';

const packageJson = require('../package.json');

const CacheBuster = () => {
  let location = useLocation();

  useEffect(() => {
    console.log(`Initial cache already cleared: ${localStorage.getItem('initialCacheCleared') || 'No'}`);
    if (localStorage.getItem('initialCacheCleared') !== 'Yes') {
      caches
        ?.keys?.()
        ?.then((keyList = []) =>
          Promise.all(
            keyList?.map?.(key => {
              return caches?.delete?.(key);
            })
          )
            .then(() => {
              localStorage.setItem('initialCacheCleared', 'Yes');
              console.log('Initial cache cleared');
            })
            .catch(e => console.log('Initial cache clearing failed: ', e))
        )
        .catch(e => console.log('An error occurred while clearing initial cache: ', e));
    }
  }, []);

  useEffect(() => {
    console.log('Fetching latest build date');
    fetch(`/meta.json?${new Date().getTime()}`, { cache: 'no-cache' })
      .then(response => response.json())
      .then(meta => {
        const latestVersionDate = Number(meta.buildDate || 0);
        const currentVersionDate = Number(packageJson.buildDate || 0);
        console.log(
          `Latest version: ${latestVersionDate ? moment(latestVersionDate).format('MMM DD, YYYY hh:mmA') : 0}, Current version: ${
            currentVersionDate ? moment(currentVersionDate).format('MMM DD, YYYY hh:mmA') : 0
          }`
        );
        if (latestVersionDate > currentVersionDate) {
          caches
            ?.keys?.()
            ?.then((keyList = []) =>
              Promise.all(
                keyList?.map?.(key => {
                  return caches?.delete?.(key);
                })
              )
                .then(() => {
                  console.log('Cache cleared. Reloading the website!');
                  window.location.reload();
                })
                .catch(e => console.log('Cache clearing failed: ', e))
            )
            .catch(e => console.log('An error occurred while fetching cache: ', e));
        }
      })
      .catch(e => console.log('An error occurred while fetching meta.json: ', e));
  }, [location?.pathname]);
  return null;
};

export default CacheBuster;
